module.exports = __webpack_public_path__ + "static/media/ESPOL-ExperienciaEstudiantil.13ca78f1.svg";